import { createSelector } from '@ngrx/store';
import { AppState } from 'src/store/appstate';

export const selectAllCommunicationCenters = (appState: AppState) =>
  appState.entityStores.communicationCenter.entities;

export function selectCommunicationCenterById(id: string) {
  return createSelector(selectAllCommunicationCenters, (commCenters) => commCenters.get(id));
}

export function selectCommunicationCentersByCompany(companyId: string) {
  return createSelector(selectAllCommunicationCenters, (commCenters) =>
    commCenters.filter((cc) => cc.companyId === companyId),
  );
}
